import React from "react";

interface MemberIconProps {
  iconColor?: string; // Color of the text inside the icon
  iconBgColor?: string; // Background color of the circular icon
  iconText?: string; // Text inside the icon (e.g., initials)
  statusColor?: string; // Status indicator color (e.g., green for online)
  iconClassName?: string;
  statusClassName?: string;
  iconTextClassName?: string;
}

const MemberIcon: React.FC<MemberIconProps> = ({
  iconColor = "white",
  iconBgColor = "#FDA85A",
  iconText,
  statusColor="#6FCF97",
  iconClassName,
  statusClassName,
  iconTextClassName
}) => {
  return (
    <div className="relative">
      <div
        className={`flex items-center justify-center w-[20px] h-[20px] rounded-full ${iconClassName}`}
        style={{ backgroundColor: iconBgColor }}
      >
        <span className={`${iconTextClassName} text-[8px] font-medium `} style={{ color: iconColor }}>
          {iconText}
        </span>
      </div>
      {/* Status Indicator (optional) */}
      {statusColor && (
        <div
          className={`${statusClassName} absolute bottom-0 right-0 w-[4px] h-[4px] rounded-full bg-[#6FCF97] `}
          // style={{ backgroundColor: statusColor }}
        />
      )}
    </div>
  );
};

export default MemberIcon;
